'use strict';

import SimpleBar from 'simplebar';

export const scrollbar = (() => {
    let $wWidth = 0;

    /**
     * init
     */
    const init = () => {
        const w = parseInt($('body').width());

        $('.js-custom-scrollbar').each((index, element) => {
            new SimpleBar(element, {
                autoHide: true
            });
        });

        if (w <= 768) {
            $('.js-custom-scrollbar-sp').each((index, element) => {
                new SimpleBar(element, {
                    autoHide: true
                });
            });
        }
    };

    // public
    return {
        init: init
    };
})();